export const ItemModel = {
    code: '',
    name: '',
    item_class_id: 0,
    item_class: { name: '' },
    item_category_id: 0,
    inventory_type_id: 0,
    inventory_type: { id: 0, name: '' },
    item_category: { name: '' },
    item_unit_id: 0,
    item_unit: { name: '' },
    description: '',
    hs_code: '',
    hs_code_description: '',
    hs_code_uom_description: '',
    model: '',
    nature: 0,
    sales_branch_id: null,
    sales_branch: { name: '' },
    cost_account_id: null,
    cost_account: { name: '' },
    inventory_account_id: null,
    inventory_account: { name: '' },
    item_brands: [],
    procurement_type: 0,
    is_serial_required: 0,
    is_barcode_required: 0,
    is_used_in_shooting_galary: 0,
    status: 1,
    approval_status: 0,
    approved_at: null,
    approved_by: { name: '' },
    cost_required: null,
    cost_type: 0,
    merged_into_item_id: null,
    merged_into_item: { code: '', name: '' },
    merged_at: null,
    merged_by_id: null,

}

///////////////// Item Nature
export const ITEM_NATURE_TYPE_INVENTORY = 1;
export const ITEM_NATURE_TYPE_NON_INVENTORY = 2;

export const ITEM_NATURE_TYPE_NAMES = {
    1: 'Inventory',
    2: 'Non-Inventory',
};

export const ITEM_NATURE_TYPE_DROPDOWN_OPTIONS = [
    { value: ITEM_NATURE_TYPE_INVENTORY, label: ITEM_NATURE_TYPE_NAMES[ITEM_NATURE_TYPE_INVENTORY] },
    { value: ITEM_NATURE_TYPE_NON_INVENTORY, label: ITEM_NATURE_TYPE_NAMES[ITEM_NATURE_TYPE_NON_INVENTORY] },
]

/////////////////// Procurement Type
export const ITEM_PROCUREMENT_TYPE_IN_HOUSE = 1;
export const ITEM_PROCUREMENT_TYPE_LOCAL = 2;

export const ITEM_PROCUREMENT_TYPE_NAMES = {
    1: 'In-House',
    2: 'Local'
};

export const ITEM_PROCUREMENT_TYPE_DROPDOWN_OPTIONS = [
    { value: ITEM_PROCUREMENT_TYPE_IN_HOUSE, label: ITEM_PROCUREMENT_TYPE_NAMES[ITEM_PROCUREMENT_TYPE_IN_HOUSE] },
    { value: ITEM_PROCUREMENT_TYPE_LOCAL, label: ITEM_PROCUREMENT_TYPE_NAMES[ITEM_PROCUREMENT_TYPE_LOCAL] },
]

/////////////////// Cost Type
export const COST_TYPE_FIXED = 1;
export const COST_TYPE_VARIABLE = 2;

export const COST_TYPE_NAMES = {
    1: 'Fixed',
    2: 'Variable'
};

export const COST_TYPE_DROPDOWN_OPTIONS = [
    { value: COST_TYPE_FIXED, label: COST_TYPE_NAMES[COST_TYPE_FIXED] },
    { value: COST_TYPE_VARIABLE, label: COST_TYPE_NAMES[COST_TYPE_VARIABLE] },
]

/////////////// Status
export const ITEM_STATUS_IN_ACTIVE = 0;
export const ITEM_STATUS_ACTIVE = 1;

export const ITEM_STATUS_NAMES = {
    0: 'Inactive',
    1: 'Active'
};

export const ITEM_STATUS_DROPDOWN_OPTIONS = [
    { value: ITEM_STATUS_IN_ACTIVE, label: ITEM_STATUS_NAMES[ITEM_STATUS_IN_ACTIVE] },
    { value: ITEM_STATUS_ACTIVE, label: ITEM_STATUS_NAMES[ITEM_STATUS_ACTIVE] },
]

/////////////// Approval Status
export const ITEM_APPROVAL_STATUS_PENDING = 0;
export const ITEM_APPROVAL_STATUS_APPROVED = 1;

export const ITEM_APPROVAL_STATUS_NAMES = {
    0: 'Unlocked',
    1: 'Locked',
};

export const ITEM_APPROVAL_STATUS_DROPDOWN_OPTIONS = [
    { value: ITEM_APPROVAL_STATUS_PENDING, label: ITEM_APPROVAL_STATUS_NAMES[ITEM_APPROVAL_STATUS_PENDING] },
    { value: ITEM_APPROVAL_STATUS_APPROVED, label: ITEM_APPROVAL_STATUS_NAMES[ITEM_APPROVAL_STATUS_APPROVED] },
]


/////////// Is Serial Required
export const ITEM_IS_SERIAL_NOT_REQUIRED = 0;
export const ITEM_IS_SERIAL_REQUIRED = 1;

export const ITEM_IS_SERIAL_REQUIRED_NAMES = {
    0: 'Not Required',
    1: 'Required',
};

export const ITEM_IS_SERIAL_REQUIRED_DROPDOWN_OPTIONS = [
    { value: ITEM_IS_SERIAL_NOT_REQUIRED, label: ITEM_IS_SERIAL_REQUIRED_NAMES[ITEM_IS_SERIAL_NOT_REQUIRED] },
    { value: ITEM_IS_SERIAL_REQUIRED, label: ITEM_IS_SERIAL_REQUIRED_NAMES[ITEM_IS_SERIAL_REQUIRED] },
]

/////////// Is Serial Required
export const ITEM_IS_BARCODE_NOT_REQUIRED = 0;
export const ITEM_IS_BARCODE_REQUIRED = 1;

export const ITEM_IS_BARCODE_REQUIRED_NAMES = {
    0: 'Not Required',
    1: 'Required',
};

export const ITEM_IS_BARCODE_REQUIRED_DROPDOWN_OPTIONS = [
    { value: ITEM_IS_BARCODE_NOT_REQUIRED, label: ITEM_IS_BARCODE_REQUIRED_NAMES[ITEM_IS_BARCODE_NOT_REQUIRED] },
    { value: ITEM_IS_BARCODE_REQUIRED, label: ITEM_IS_BARCODE_REQUIRED_NAMES[ITEM_IS_BARCODE_REQUIRED] },
]
